import React from 'react';

export default function SortIcon({ onClick, isActive, direction }) {
    let icon = '⇅';
    if (isActive) {
        icon = direction === 'asc' ? '▲' : '▼';
    }
    return (
        <span className="sort-icon" onClick={onClick}>
      {icon}
    </span>
    );
}
